import React, {useEffect, useState} from 'react';
import './ProjectsDocuments.scss';
import ProjectsHero from '../../Components/Projects/ProjectsHero';
import ProjectsSearchPanel from '../../Components/Projects/ProjectsSearchPanel';
import ProjectsItem from '../../Components/Projects/ProjectsItem';
import {useHistory, useParams} from 'react-router-dom';
import SingleDocument from './SingleDocument/SingleDocument';
import {mainPath} from '../../../routes/paths';
import ProjectsNewFile from '../../Components/Projects/ProjectsNew/ProjectsNewFile';
import {ButtonMUI, IconButtonMUI, SelectComponent} from '../../../shared';
import PopoverMui from '../../../shared/PopoverMui/PopoverMui';
import {ReactComponent as DownloadFile} from '../../../assets/icons/downloadFile.svg';
import {ReactComponent as TrashIcon} from '../../../assets/icons/trash.svg';
import {ReactComponent as SignatureIcon} from '../../../assets/icons/signature.svg';
import {ReactComponent as Edit2Svg} from '../../../assets/icons/edit-3.svg';

import {ReactComponent as RejectIcon} from '../../../assets/icons/reject.svg';
import {ReactComponent as Dots} from '../../../assets/icons/dots.svg';
import {ReactComponent as AddFileSvg} from '../../../assets/icons/addFile.svg';
import {ReactComponent as EyeSvg} from '../../../assets/icons/eye.svg';
import {ReactComponent as Remember} from '../../../assets/icons/remember.svg';

import {
    approveDoc,
    deleteDoc,
    deleteDocs,
    downloadDoc,
    getDocument,
    getDocuments,
    rejectDoc,
    requestApproval,
    resetSingleDoc
} from '../../../redux/actions/documents/documentsActions';
import {useDispatch, useSelector} from 'react-redux';
import LoadPanel from '../../Components/LoadPanel';
import NoItems from '../../Components/NoItems';
import {notifySuccess} from '../../../helpers/notifySnack';
import {mimeTypesBrowserSupport, PERMISSIONS} from '../../../helpers/constants';
import {getProject} from '../../../redux/actions/projects/projectsActions';
import {acceptGeneralFormats, getIconForFormat, hasPermission} from '../../../helpers/functions';
import {useTranslation} from 'react-i18next';
import {closeModal, setModal, setModalData, showConfirmPopup} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import {downloadHandlerFiles, viewHandlerFiles} from "../../../helpers/files";

const ProjectsDocuments = () => {
    const dispatch = useDispatch();
    const [showNewFile, setShowNewFile] = useState(false);
    const {documents, singleDocument, singleDocumentLoading} = useSelector(({documents}) => documents);
    const [filterQuery, setFilterQuery] = useState('all');
    const {singleProject} = useSelector((state) => state.projects);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const {t} = useTranslation();

    const [submitted, setSubmitted] = useState(false);
    const [searchVal, setSearchVal] = useState('');

    const profileMe = useSelector((state) => state.profile.profileMe);
    const allowActions = singleProject?.status === 'active' || singleProject?.status === 'pause'
    const allowActionsApproveReject = singleProject?.status === 'active' || singleProject?.status === 'pause' || profileMe?.role === 'super-admin'

    const handleClickAnchor = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openState = Boolean(anchorEl);

    const history = useHistory();

    const {documentId, id} = useParams();

    const isSinglePage = documentId;

    const [checkedItems, setCheckedItems] = useState([]);

    const [isCheckAll, setIsCheckAll] = useState(false);

    const handleCheck = (id) => {
        setCheckedItems((prev) => (prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]));
    };

    const handleCheckAll = () => {
        if (isCheckAll) {
            setCheckedItems([]);
        } else {
            setCheckedItems(filteredDocuments.map((doc) => doc.id));
        }
        setIsCheckAll(!isCheckAll);
    };

    const handleSearch = (value) => {
        setSearchVal(value);
        clearCheckboxes();
    };

    const handleClear = () => {
        setSearchVal('');
        clearCheckboxes();
    };

    const clearCheckboxes = () => {
        setIsCheckAll(false);
        setCheckedItems([]);
    };

    const downloadAllHandler = () => {
        if (checkedItems.length) {
            dispatch(setModal(POPUPS.PREPARING_POPUP));
            dispatch(downloadDoc(checkedItems)).then((res) => {
                if (res.payload) {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(res.payload.data);
                    link.download = 'items.zip';
                    document.body.appendChild(link);

                    link.click();

                    link.parentNode.removeChild(link);
                    dispatch(closeModal());
                } else {
                    dispatch(closeModal());
                }
            });
        }
    };

    const removeHandler = async (documentId) => {
        if (!submitted) {
            setSubmitted(true);
            const res = await dispatch(deleteDoc(id, documentId));

            if (res.payload) {
                setSubmitted(false);
                notifySuccess(t('ProjectsDocuments.successDelete'));
                handleNavigate();
                await dispatch(getProject(id));
            } else {
                setSubmitted(false);
            }
        }
    };

    const removeHandlerAll = async () => {
        setSubmitted(true);
        const res = await dispatch(deleteDocs(id, checkedItems));
        if (res.payload) {
            setSubmitted(false);
            handleNavigate();
            notifySuccess(t('ProjectsDocuments.successDelete'));
            await dispatch(getProject(id));
        } else {
            setSubmitted(false);
        }
    };

    const handleNavigate = () => {
        history.push(mainPath.projectsDocuments.replace(':id', id));
        setShowNewFile(false);
    };

    const handleNavigateNew = () => {
        setShowNewFile(true);
    };

    function getDocumentWord(count) {
        if (count % 100 >= 11 && count % 100 <= 19) {
            return t('ProjectsDocuments.documents.many'); // виняток для чисел від 11 до 19
        }

        switch (count % 10) {
            case 1:
                return t('ProjectsDocuments.documents.single'); // 1 документ
            case 2:
            case 3:
            case 4:
                return t('ProjectsDocuments.documents.few'); // 2, 3, 4 документи
            default:
                return t('ProjectsDocuments.documents.many'); // 5-9, 0 документів
        }
    }

    const redirectUrl = mainPath.projectsDocument;

    useEffect(() => {
        const fetchData = async () => {
            await dispatch(getDocuments(id, 'document'));
        };
        fetchData();

        return () => {
            setShowNewFile(false);
        }
    }, [id]);

    useEffect(() => {
        const fetchFunc = async () => {
            try {
                const res = await dispatch(getDocument(id, documentId));
                if (res?.error?.response?.status === 409) {
                    handleNavigate();
                }
            } catch (err) {
                console.log(err);
            }
        };
        if (documentId) {
            fetchFunc();
        }

        return () => {
            if (documentId) {
                dispatch(resetSingleDoc());
            }
        };
    }, [documentId, id]);

    const filteredDocuments = documents?.items?.filter((doc) => {
        const matchesSearch = doc.name.toLowerCase().includes(searchVal.toLowerCase());
        const matchesFilter = filterQuery === 'all' || doc.status === filterQuery;

        return matchesSearch && matchesFilter;
    });

    const requestApproveHandler = async () => {
        const res = await dispatch(requestApproval(id, documentId));

        if (res.payload) {
            const responseDoc = await dispatch(getDocument(id, documentId));
            if (responseDoc.payload) {
                const response = await dispatch(getDocuments(id, 'document'));
                if (response.payload) {
                    notifySuccess(t('all.docRequest'));
                }
            }
        }
    };

    const requestApproveHandlerDocId = async (docId) => {
        let dId = documentId ?? docId;

        if (submitted) return;
        setSubmitted(true);
        const res = await dispatch(requestApproval(id, dId));
        if (res.payload) {
            notifySuccess(t('all.successfully'));
            setSubmitted(false);
        }
        setSubmitted(false);
    };

    const approveHandler = async () => {
        const res = await dispatch(approveDoc(id, documentId));

        if (res.payload) {
            const responseDoc = await dispatch(getDocument(id, documentId));
            if (responseDoc.payload) {
                const response = await dispatch(getDocuments(id, 'document'));
                if (response.payload) {
                    notifySuccess(t('all.docApprove'));
                }
            }
        }
    };
    const rejectHandler = async () => {
        const res = await dispatch(rejectDoc(id, documentId));

        if (res.payload) {
            const responseDoc = await dispatch(getDocument(id, documentId));
            if (responseDoc.payload) {
                const response = await dispatch(getDocuments(id, 'document'));
                if (response.payload) {
                    notifySuccess(t('all.docReject'));
                }
            }
        }
    };

    const removeHandlerSingleRedux = (documentId) => {
        dispatch(
            showConfirmPopup({
                visible: true,
                confirmCallback: () => removeHandler(documentId)
            })
        );
    };
    const removeHandlerMultipleRedux = () => {
        if (checkedItems.length) {
            dispatch(
                showConfirmPopup({
                    visible: true,
                    confirmCallback: () => removeHandlerAll()
                })
            );
        }
    };
    const rejectHandlerRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('SingleDocument.reject'),
                text: t('all.docReallyReject'),
                confirmCallback: () => rejectHandler()
            })
        );
    };
    const acceptHandlerRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('SingleDocument.approve'),
                text: t('all.docReallyApprove'),
                confirmCallback: () => approveHandler()
            })
        );
    };

    const handleFilterChange = (e) => {
        setFilterQuery(e.target.value);
        clearCheckboxes();
    };

    const options = [
        {
            id: 'all',
            name: t('all.all')
        },
        {
            name: t('ProjectsItem.status_requested'),
            id: 'requested'
        },
        {
            name: t('ProjectsItem.status_confirm'),
            id: 'approved'
        },
        {
            name: t('ProjectsItem.status_reject'),
            id: 'rejected'
        }
    ];

    const downloadPermission = hasPermission(PERMISSIONS.DOCUMENT_DOWNLOAD, profileMe?.permissions ?? []);
    const addPermission = hasPermission(PERMISSIONS.DOCUMENT_CREATE, profileMe?.permissions ?? []);
    const trashPermission = hasPermission(PERMISSIONS.DOCUMENT_REMOVE, profileMe?.permissions ?? []);
    const requestPermission = hasPermission(PERMISSIONS.DOCUMENT_REQUEST, profileMe?.permissions ?? []);
    const acceptPermission = hasPermission(PERMISSIONS.DOCUMENT_ACCEPT, profileMe?.permissions ?? []);
    const permissionChangeStatus = hasPermission(PERMISSIONS.DOCUMENT_STATUS_EDIT, profileMe?.permissions ?? []);

    const isSupportView = (mime) => mimeTypesBrowserSupport?.includes(mime);

    const changeStatus = () => {
        dispatch(setModal(POPUPS.STATUS_DOC));
        dispatch(setModalData({
            id: singleDocument.id,
            projectId: singleProject.id,
            paymentStatus: singleDocument.paymentStatus,
            isSinglePage: true
        }))
    }

    return (
        <div className={'projects__documents'}>
            <>
                {documents.loading ? (
                    <LoadPanel noBg={true} circleSize={40} staticPos={true}/>
                ) : (
                    <>
                        <ProjectsHero
                            heading={t('ProjectsDocuments.heading')}
                            subHeading={`${documents.items?.length ?? 0} ${getDocumentWord(documents.items?.length ?? 0)}`}
                            showArrow={isSinglePage || showNewFile}
                            buttonHandler={handleNavigate}
                            buttons={
                                <>
                                    {addPermission && !isSinglePage && !showNewFile && allowActions ? (
                                        <>
                                            <div className='projects__hero-icon projects__hero-icon-mob'
                                                 onClick={handleNavigateNew}>
                                                <IconButtonMUI color={'default'}
                                                               title={t('ProjectsDocuments.no_items_button')}>
                                                    <AddFileSvg/>
                                                </IconButtonMUI>
                                            </div>
                                        </>
                                    ) : null}

                                    {isSinglePage && (
                                        <>
                                            {downloadPermission && (
                                                <>
                                                    {isSupportView(singleDocument?.mime) && <div
                                                        className='projects__hero-icon projects__hero-icon--purple'
                                                        onClick={() => {
                                                            const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                            const fileName = singleDocument?.name + (getFormat?.[0] || '')
                                                            viewHandlerFiles({
                                                                file: singleDocument?.file,
                                                                name: fileName,
                                                                docId: singleDocument?.id,
                                                                projectId: singleProject?.id,
                                                            }, dispatch);
                                                            handleClose();
                                                        }}
                                                    >
                                                        <IconButtonMUI color={'default'}
                                                                       title={t('ProjectsDrawing.view_document')}>
                                                            <EyeSvg/>
                                                        </IconButtonMUI>
                                                    </div>}
                                                    <div
                                                        className='projects__hero-icon'
                                                        onClick={() => {
                                                            const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                            const fileName = singleDocument?.name + (getFormat?.[0] || '')
                                                            downloadHandlerFiles({

                                                                file: singleDocument?.file,
                                                                name: fileName,
                                                                docId: singleDocument?.id,
                                                                projectId: singleProject?.id,
                                                            }, dispatch)

                                                        }}
                                                    >
                                                        <IconButtonMUI color={'default'}
                                                                       title={t('ProjectsDocuments.download')}>
                                                            <DownloadFile/>
                                                        </IconButtonMUI>
                                                    </div>
                                                </>
                                            )}
                                            {trashPermission && allowActions && (
                                                <div
                                                    className='projects__hero-icon'
                                                    onClick={() => {
                                                        removeHandlerSingleRedux(singleDocument?.id);
                                                    }}
                                                >
                                                    <IconButtonMUI color={'default'}
                                                                   title={t('ProjectsDocuments.delete')}>
                                                        <TrashIcon/>
                                                    </IconButtonMUI>
                                                </div>
                                            )}

                                            {singleDocument && singleDocument?.status === 'new' && requestPermission && allowActions ? (
                                                <ButtonMUI
                                                    onClick={requestApproveHandler}
                                                    className={'hide-mob'}
                                                    variant={'outlined'}
                                                    size={'medium'}
                                                    startIcon={<SignatureIcon/>}
                                                >
                                                    {t('ProjectsDocuments.requestApproval')}
                                                </ButtonMUI>
                                            ) : null}
                                            {singleDocument && singleDocument?.status === 'requested' && acceptPermission && allowActionsApproveReject ? (
                                                <ButtonMUI
                                                    onClick={acceptHandlerRedux}
                                                    className={'hide-mob'}
                                                    variant={'outlined'}
                                                    size={'medium'}
                                                    startIcon={<SignatureIcon/>}
                                                >
                                                    {t('ProjectsDocuments.approve')}
                                                </ButtonMUI>
                                            ) : null}
                                            {singleDocument && singleDocument?.status === 'requested' && acceptPermission && allowActionsApproveReject ? (
                                                <ButtonMUI
                                                    color={'secondary'}
                                                    className={'hide-mob'}
                                                    onClick={rejectHandlerRedux}
                                                    variant={'outlined'}
                                                    size={'medium'}
                                                    startIcon={<RejectIcon/>}
                                                >
                                                    {t('SingleDocument.reject')}
                                                </ButtonMUI>
                                            ) : null}
                                            {singleDocument && singleDocument?.status === 'approved' && allowActions && permissionChangeStatus ?
                                                <div
                                                    onClick={() => {
                                                        changeStatus();
                                                    }}
                                                >
                                                    <IconButtonMUI
                                                        className={'hide-mob'}
                                                        color={'default'} title={t('all.status')}>
                                                        <Edit2Svg/>
                                                    </IconButtonMUI>
                                                </div> : null}

                                            <div className='projects__hero-dropdown'>
                                                <Dots onClick={handleClickAnchor}/>
                                                <PopoverMui
                                                    open={openState}
                                                    handleClose={() => {
                                                        handleClose();
                                                    }}
                                                    anchorEl={anchorEl}
                                                >
                                                    {downloadPermission ? (
                                                        <>
                                                            {isSupportView(singleDocument?.mime) && <div
                                                                className='projects__hero-link'
                                                                onClick={() => {
                                                                    const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                                    const fileName = singleDocument?.name + (getFormat?.[0] || '')

                                                                    viewHandlerFiles({
                                                                        file: singleDocument?.file,
                                                                        name: fileName,
                                                                        docId: singleDocument?.id,
                                                                        projectId: singleProject?.id,

                                                                    }, dispatch);
                                                                    handleClose();
                                                                }}
                                                            >
                                                                <div className='projects__hero-circle'>
                                                                    <EyeSvg/>
                                                                </div>
                                                                {t('ProjectsDrawing.view_document')}
                                                            </div>}
                                                            <div
                                                                className='projects__hero-link'
                                                                onClick={() => {
                                                                    const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                                    const fileName = singleDocument?.name + (getFormat?.[0] || '')
                                                                    downloadHandlerFiles({
                                                                        file: singleDocument?.file,
                                                                        name: fileName,
                                                                        docId: singleDocument?.id,
                                                                        projectId: singleProject?.id,
                                                                    }, dispatch);
                                                                    handleClose();
                                                                }}
                                                            >
                                                                <div className='projects__hero-circle'>
                                                                    <DownloadFile/>
                                                                </div>
                                                                {t('ProjectsDrawing.download_document')}
                                                            </div>
                                                        </>
                                                    ) : null}
                                                    {trashPermission && allowActions ? (
                                                        <div
                                                            className='projects__hero-link'
                                                            onClick={() => {
                                                                removeHandlerSingleRedux(documentId);
                                                                handleClose();
                                                            }}
                                                        >
                                                            <div className='projects__hero-circle'>
                                                                <TrashIcon/>
                                                            </div>
                                                            {t('ProjectsDocuments.delete')}
                                                        </div>
                                                    ) : null}
                                                    {requestPermission && singleDocument?.status === 'requested' && allowActions ? (
                                                        <div
                                                            className='projects__hero-link'
                                                            onClick={() => {
                                                                requestApproveHandlerDocId(documentId);
                                                                handleClose();
                                                            }}
                                                        >
                                                            <div className='projects__hero-circle'>
                                                                <Remember/>
                                                            </div>
                                                            {t('all.remember')}
                                                        </div>
                                                    ) : null}
                                                    {singleDocument && singleDocument?.status === 'approved' && allowActions && permissionChangeStatus ?
                                                        <div
                                                            onClick={() => {
                                                                changeStatus();
                                                            }}
                                                            className='projects__hero-link'
                                                        >
                                                            <IconButtonMUI
                                                                className={'projects__hero-circle-new'}
                                                                color={'default'} title={t('all.status')}>
                                                                <Edit2Svg/>
                                                            </IconButtonMUI>
                                                            {t('all.status')}
                                                        </div> : null}
                                                </PopoverMui>
                                            </div>
                                        </>
                                    )}
                                </>
                            }
                        />
                        {documents.items?.length && !showNewFile ? (
                            <>
                                {!isSinglePage ? (
                                    <>
                                        <ProjectsSearchPanel
                                            searchVal={searchVal}
                                            handleClear={handleClear}
                                            handleChange={(e) => handleSearch(e.target.value)}
                                            isCheckAll={isCheckAll}
                                            handleCheckAll={handleCheckAll}
                                            checkedItems={checkedItems}
                                            removeHandlerAll={removeHandlerMultipleRedux}
                                            downloadAllHandler={downloadAllHandler}
                                            permissionTrash={trashPermission && allowActions}
                                            permissionDownload={downloadPermission}
                                        />
                                        <div className={'projects__filter'}>
                                            <SelectComponent
                                                onChange={handleFilterChange}
                                                value={filterQuery}
                                                options={options}
                                                allowClear={false}
                                                fullWidth={true}
                                                label={t('all.filter')}
                                            />
                                        </div>
                                        <div className='projects__list'>
                                            {filteredDocuments.map((el) => {
                                                return (
                                                    <ProjectsItem
                                                        key={el.id}
                                                        el={el}
                                                        checked={checkedItems.includes(el.id)}
                                                        onCheck={() => handleCheck(el.id)}
                                                        projectId={id}
                                                        redirectUrl={redirectUrl}
                                                        removeHandler={removeHandlerSingleRedux}
                                                        permissionTrash={trashPermission && allowActions}
                                                        permissionDownload={downloadPermission}
                                                        remindPermission={requestPermission && allowActions}
                                                        remindProject={true}
                                                        requestApproveHandler={requestApproveHandlerDocId}
                                                        permissionChangeStatus={permissionChangeStatus}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </>
                                ) : (
                                    <SingleDocument
                                        handleNavigate={handleNavigate}
                                        approveHandler={acceptHandlerRedux}
                                        singleDocument={singleDocument}
                                        singleDocumentLoading={singleDocumentLoading}
                                        requestApproveHandler={requestApproveHandler}
                                        rejectHandler={rejectHandlerRedux}
                                        acceptPermission={acceptPermission && allowActionsApproveReject}
                                        requestPermission={requestPermission && allowActions}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {!showNewFile && (
                                    <>
                                        <NoItems
                                            description={t('ProjectsDocuments.no_items_description')}
                                            title={t('ProjectsDocuments.no_items_title')}
                                            handleNavigate={handleNavigateNew}
                                            buttonText={t('ProjectsDocuments.no_items_button')}
                                            center={'center'}
                                            disabled={!allowActions || !addPermission}
                                        />
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}
            </>
            {showNewFile && <ProjectsNewFile setShowNewFile={setShowNewFile} type={'document'}/>}
        </div>
    );
};

export default ProjectsDocuments;
